import { render, staticRenderFns } from "./numberStatic.vue?vue&type=template&id=510b2ced"
import script from "./numberStatic.js?vue&type=script&lang=js&external"
export * from "./numberStatic.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports